/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'

export function AsideMenuMain() {
	const intl = useIntl()

	return (
		<>
			<AsideMenuItem
				to='/dashboard'
				icon='/media/icons/duotune/abstract/abs014.svg'
				title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
				fontIcon='bi-app-indicator'
			/>
			<AsideMenuItemWithSub
				to='/setup'
				title='Setup'
				icon='/media/icons/duotune/general/gen019.svg'>
				<AsideMenuItem to='/delivery-associates' title='Delivery Associates' icon='/media/icons/duotune/transportation/trs002.svg' />
			</AsideMenuItemWithSub>
			<AsideMenuItemWithSub
			  to='/customer'
			  title='Customer'
			  icon='/media/svg/icons/Communication/Clipboard-list.svg'>
				<AsideMenuItem to='/customer-list' title='Customer List' icon='/media/svg/icons/Communication/Clipboard-list.svg' />
			</AsideMenuItemWithSub>
			<AsideMenuItemWithSub
				to='/payment'
				title='Payment'
				icon='/media/icons/duotune/abstract/abs025.svg'>
				<AsideMenuItem to='/payment-list' title='Payment List' icon='/media/svg/icons/Text/Bullet-list.svg' />
			</AsideMenuItemWithSub>
			<AsideMenuItemWithSub
				to='/product'
				title='Product'
				icon='/media/svg/icons/Shopping/Box2.svg'>
				<AsideMenuItem to='/product-list' title='Product List' icon='/media/svg/icons/Shopping/Box2.svg' />
			</AsideMenuItemWithSub>
		
			<AsideMenuItemWithSub
				to='/sales'
				title='Sales'
				icon='/media/svg/icons/Shopping/Cart1.svg'>
				<AsideMenuItem to='/sales-orders' title='Orders' icon='/media/svg/icons/Shopping/Bag1.svg' />
				<AsideMenuItem to='/sales-orders/create' title='Create Order' icon='/media/svg/icons/General/Plus.svg' />
				<AsideMenuItem to='/sales-invoices' title='Invoices' icon='/media/svg/icons/Text/Bullet-list.svg' />
				<AsideMenuItem to='/shipments' title='Shipments' icon='/media/svg/icons/Transportation/Truck.svg' />
				<AsideMenuItem to='/payments/receive' title='Payment Receive' icon='/media/svg/icons/Finance/Money.svg' />
			</AsideMenuItemWithSub>

			<AsideMenuItemWithSub
				to='/purchase'
				title='Purchase'
				icon='/media/svg/icons/Shopping/Cart2.svg'>
				<AsideMenuItem to='/purchase-orders' title='Purchase Orders' icon='/media/svg/icons/Shopping/Bag2.svg' />
				<AsideMenuItem to='/purchase-orders/create' title='Create Purchase Order' icon='/media/svg/icons/General/Plus.svg' />
				<AsideMenuItem to='/suppliers' title='Suppliers' icon='/media/svg/icons/Communication/Clipboard-list.svg' />
			</AsideMenuItemWithSub>
		
			<AsideMenuItemWithSub
				to='/accesscontrol'
				title='Access Control'
				icon='/media/svg/icons/General/Lock.svg'>
				<AsideMenuItem to='/accesscontrol-rolemanagement' title='Role Management' icon='/media/svg/icons/Communication/Clipboard-list.svg' />
				<AsideMenuItem to='/accesscontrol-page-list' title='page Management' icon='/media/svg/icons/Communication/Clipboard-list.svg' />
				<AsideMenuItem to='/accesscontrol-userrolepermission' title='User Role Permission' icon='/media/svg/icons/Communication/Clipboard-list.svg' />
			</AsideMenuItemWithSub>

		</>
	)
}
